
import React, { useMemo, useState } from 'react';
import SchedulePage from './Schedule';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import PageHeader from 'components/common/PageHeader';

export default function ScheduleContext() {
    const { mirs_discipline } = useUrlFriendlyToParameters();
    return (
        <>
            {mirs_discipline && <SchedulePage />}
            {!mirs_discipline && <SchediuleAll />}
        </>
    );

};



function SchediuleAll() {
    return (
        <>
            <PageHeader title='Schedule Complete' />
            <div>To do</div>
        </>
    )
};

